import type { UserProfileResponse } from '@/types';
import type { BaseResponse } from '@/types/common/http';
import { request } from '@/utils/request';

/**
 * 获取当前用户资料
 */
export function getUserProfile() {
  return request.post<BaseResponse<UserProfileResponse>>('/Profile/GetProfiles');
}
